import DAO from './DAO.js';
import OfflineQueue from './queue/OfflineQueue';
import referenceDocumentsServices from '../services/referenceDocumentsServices';
import StoreItemProcessing from '../helpers/StoreFunctions/StoreItemProcessing';
import dataModel from '../models/DataModel';

export default class ReferenceDocumentsDAO extends DAO {

  constructor(store) {
    super(store, 'reference_document');
    this.OfflineQueue = OfflineQueue;

    this.unsetReferenceDocument = this.unsetReferenceDocument.bind(this);
    this.clearReferenceDocuments = this.clearReferenceDocuments.bind(this);
  }

  unsetReferenceDocument(id) {
    StoreItemProcessing.deleteItemInStore(this.itemType, id);
  }

  clearReferenceDocuments() {
    StoreItemProcessing.clearItemsInStore(this.itemType);
  }

  getReferenceDocument(docId, options) {
    if (!options) {
      options = { recordDescriptor: { reference_document: { conversions: { additionalFields: ['upload'] } }, additionalFields: ['attachment'] } }; 
    }
    return this._getItem(docId, referenceDocumentsServices.getReferenceDocument.bind(this, docId, options), options);
  }

  deleteReferenceDocument(docId) {
    const referenceDocument = this.findItem(docId);
    return referenceDocumentsServices.deleteReferenceDocument(docId).then(response => {
      if (response.error){
        dataModel.showGlobalModal('SYSTEM_POPUP', {
          message: 'Failed to delete the reference document.',
          captionText: 'ERROR',
          width: 300,
          height: 184,
          okButtonText: 'OK',
          oneButton: true,
        }); 
        return null;
      } else {
        this.unsetReferenceDocument(docId);
        this.markDeleted(referenceDocument);
        return response;
      }
    });
  }

  async getGroupIdentifier(groupIdentifier, options) {
    if (!options) {
      options = { recordDescriptor: { reference_document: { conversions: { additionalFields: ['upload'] } }, additionalFields: ['attachment'] } }; 
    }
    return referenceDocumentsServices.getReferenceDocumentsByGroup(groupIdentifier, options).then(response => {
      const storeItem = this.normalizeAndSyncToStore(response);
      return this.mapToReturn(storeItem, options);
    });
  }

  async createReferenceDocument(referenceDocument) {
    return referenceDocumentsServices.createReferenceDocument(referenceDocument, null).then(response => {
      if (response.error) {
        if(response.error.response && response.error.response.status == 422 && response.error.response.data.code){
          dataModel.showGlobalModal('SYSTEM_POPUP', {
            message: 'The Reference Document ' + referenceDocument.name + ' cannot be used. It already exists.',
            captionText: 'ERROR',
            width: 300,
            height: 184,
            okButtonText: 'OK',
            oneButton: true,
          }); 
          dataModel.displayInfoErrorMessage('Document upload unsuccessful', 4000, 2);
          return null;
        }
        else if(response.error.response && response.error.response.status == 418){
          dataModel.showGlobalModal('SYSTEM_POPUP', {
            message: `The document ${referenceDocument.name} already exists. To replace the current version, select the ${referenceDocument.name} in the library and replace from the document details page.`,
            captionText: 'ERROR',
            width: 300,
            okButtonText: 'OK',
            oneButton: true,
          }); 
          return null;
        }
        else{
          dataModel.displayHTTPError('Creating a Reference Document ', response.error);
          return null;
        }
      } 
      else {
        return response.reference_document;
      }
    });
  }

  handleActionCableAndGetRequest(acData) {
    const referenceDocument = this.findItem(acData.reference_document_id);
    if (referenceDocument) {
      if (acData.is_attribute_update) {
        this.markNeedsAttributeSync(referenceDocument);
      }
      else {
        this.markNeedsSync(referenceDocument);
      }
      switch (acData.type) {
      case 'newReferenceDocument':
      case 'updateReferenceDocument':
        return this.getReferenceDocument.bind(this);
      case 'deleteReferenceDocument':
        break;
      default:
      }
    }
  }

  clearState(options) {
    this.clearMyState(this.stateTree.new_reference_documents, options.toIgnore.referenceDocuments, this.unsetReferenceDocument, this.clearReferenceDocuments, options);
  }
}



// WEBPACK FOOTER //
// ./src/dao/ReferenceDocumentsDAO.js